module.exports = __webpack_public_path__ + "static/img/WebComponentsIcons.a45f0eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/glyphs/WebComponentsIcons.svg?gedxeo
// module id = 1632
// module chunks = 28